import {HttpService} from '../services';
import {Injectable} from "@angular/core";
import { environment } from 'environments/environment';
import { ScriptsUtility } from './scripts.utility';
import { SSOUtility } from './sso.utility';

export class AgentUtility {

    public static readonly NAME_OTHER_FIELD: string = "otheruser";
    public static readonly NAME_USER_FIELD: string = "user";
    public static readonly NAME_COUNT_CONTRACTS: string = "countContracts";
    public static readonly NAME_PERM_FIELD:string = "perm";
    public static readonly NAME_TOKEN_FIELD:string = "token";
    public static readonly ACCESS_DENIED = "access-denied";

    public static setToken(token:string){
        localStorage.setItem(AgentUtility.NAME_TOKEN_FIELD,token);
    }
    
    public static getToken():string{
       return localStorage.getItem(AgentUtility.NAME_TOKEN_FIELD);
    }

    public static isAuth():boolean{
        let token = this.getToken();
        if(!token)
            return false;
        if(token == this.ACCESS_DENIED)
            return false;
        return true;
    }

    public static setPerm(perm:any){
        localStorage.setItem(AgentUtility.NAME_PERM_FIELD,JSON.stringify(perm));
    }

    public static setUser(user:any){
        localStorage.setItem(AgentUtility.NAME_USER_FIELD,JSON.stringify(user));
    }

    public static getUser(): any {
        var otherUser = JSON.parse(localStorage.getItem(AgentUtility.NAME_OTHER_FIELD));
        if (otherUser)
            return otherUser;
        else {
            var currentUser = JSON.parse(localStorage.getItem(AgentUtility.NAME_USER_FIELD));
            if (currentUser)
                return currentUser;
            else
                return false;
        }
    }

    public static getLocalUser() {
        var currentUser = JSON.parse(localStorage.getItem(AgentUtility.NAME_USER_FIELD));
        if (currentUser)
            return currentUser;
        else
            return false;
    }

    public static getV_Agent(): any {
        var v_agent = AgentUtility.getUser().v_agent;
        return v_agent;
    }


    public static setOtherUserInfo(obj: any) {
        AgentUtility.DelCountCache();
        localStorage.setItem(AgentUtility.NAME_OTHER_FIELD, JSON.stringify(obj));
    }

    public static delOtherUserInfo() {
        localStorage.removeItem(AgentUtility.NAME_OTHER_FIELD);
    }

    public static IsOther(): boolean {
        return localStorage.getItem(AgentUtility.NAME_OTHER_FIELD) != null;
    }

    public static IsNormal(): boolean {
        return localStorage.getItem(AgentUtility.NAME_USER_FIELD) != null;
    }

    public static GetCountCache(): any {
        var countLocal = localStorage.getItem(AgentUtility.NAME_COUNT_CONTRACTS);
        if (countLocal == null || countLocal == undefined)
            return null;
        else {
            var res = parseInt(countLocal);
            if (isNaN(res))
                return 0;
            return parseInt(countLocal);

        }
    }

    public static SetCountCache(count: string): void {
        localStorage.setItem(AgentUtility.NAME_COUNT_CONTRACTS, count);
    }

    public static DelCountCache(): void {
        localStorage.removeItem(AgentUtility.NAME_COUNT_CONTRACTS);
    }

    public static IsAdmin():boolean{
        let user = this.getUser();
        if(!user)
            return false;
        return user.RoleId == 1
    }

    public static IsSale():boolean{
        let user = this.getUser();
        
        if(user.CategoryId != undefined){
            if(user.CategoryId == 2)//Агент
                return true;
            if(user.CategoryId == 3)//Менеджер
                return true;
            if(user.CategoryId == 4)//Директор агентства 1 года 
                return true;
            if(user.CategoryId == 20)//Директор агентства 2 года
                return true;
            if(user.CategoryId == 50)//Территориальный директор
                return true;
        }           
        return false;
    }

    public static IsAgent():boolean{
        let user = this.getLocalUser();
        if(!user)
            return false;
        if(user.Id == 3)
            return false;
            
        return user.CategoryId == 2
    }

    public static IsManager():boolean{
        let user = this.getLocalUser();
        if(!user)
            return false;
        return user.CategoryId == 3
    }
}